import { Link } from "react-router-dom";
import SideBar from "components/sidebar/Sidebar";

import bellIcon from "assets/images/Bell-Icon.png";
import { LoggedInUserContext } from "contexts/user";
import { useContext } from "react";

function HomePage() {
  const me = useContext(LoggedInUserContext);

  return (
    <>
      <div className="wrapper">
        <SideBar />
        <div className="main_content">
          {me && (
            <div className="header">
              <ul>
                {me && (
                  <>
                    <li>
                      <img src={bellIcon} alt="notification bell icon" />
                    </li>
                    <li>
                      <div className="profilePic">
                        Hey,{" "}
                        <Link to={`/profile/${me?.nickname!}`}>
                          {/* <img src="/images/Profile_Pic.png" /> */}
                          {me?.nickname}!
                        </Link>
                      </div>
                    </li>
                  </>
                )}

                {!me && (
                  <>
                    <li>
                      <Link to="/auth/login">Login</Link>
                    </li>
                    <li>
                      <Link to="/auth/register">Register</Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
          )}

          <div className="container">
            <img
              className="gfg"
              src="/images/Hero-Image.jpg"
              alt="Hero"
            />
            <div className="hero-text">
              <h1>WELCOME TO JIWE ESPORTS</h1>
              <h2>ALL GAME, ALL THE TIME</h2>
            </div>
          </div>
        </div>
      </div>
      <h1 className="Fgames">Featured Games</h1>
      <h2 className="Cmore">See More</h2>

      {/* <div className="parent1">
        <div className="torn1">
          <img src="/images/BackTournaments.png" alt="" />
        </div>
        <div className="torn2">
          <img src="/images/Game1.png" alt="" />
        </div>
        <div className="TournInfo">
          <p>Sat Aug 14 @ 4pm</p>
          <p>VALENTINES 15000 ESPORTS WARFARE TOURNAMENT</p>
          <p>Prize: KES 15,000</p>
          <img src="images/Fresh.png" alt="" />
        </div>
      </div>

      <div className="grid-container3">
        <div className="parent2">
          <div className="tornImg1">
            <img src="/images/BackTournaments.png" alt="" />
          </div>
          <div className="tornImg2">
            <img src="/images/Game1.png" alt="" />
          </div>
          <div className="TournInfo1">
            <p>Sat Aug 14 @ 4pm</p>
            <p>VALENTINES 15000 ESPORTS WARFARE TOURNAMENT</p>
            <p>Prize: KES 15,000</p>
          </div>
        </div>

        <div className="parent3">
          <div className="tornImg3">
            <img src="/images/BackTournaments.png" alt="" />
          </div>
          <div className="tornImg4">
            <img src="/images/Game1.png" alt="" />
          </div>
          <div className="TournInfo2">
            <p>Sat Aug 14 @ 4pm</p>
            <p>VALENTINES 15000 ESPORTS WARFARE TOURNAMENT</p>
            <p>Prize: KES 15,000</p>
          </div>
        </div>

        <div className="parent4">
          <div className="tornImg5">
            <img src="/images/BackTournaments.png" alt="" />
          </div>
          <div className="tornImg6">
            <img src="/images/Game1.png" alt="" />
          </div>
          <div className="TournInfo3">
            <p>Sat Aug 14 @ 4pm</p>
            <p>VALENTINES 15000 ESPORTS WARFARE TOURNAMENT</p>
            <p>Prize: KES 15,000</p>
          </div>
        </div>
      </div>

      <div className="grid-container4">
        <div className="playerWeek">
          <h2 className="TopPlayerh2">Jiwe eSports</h2>
          <h1 className="TopPlayerh1">PLAYER OF THE WEEKS</h1>
          <img src="/images/Best_Player.png" alt="" />
          <div className="bestPlayerInfo">
            <h2>Matt</h2>
            <p>
              Jiwe esports memeber since:{" "}
              <span style={{ color: "#ffffff" }}>June 17, 2021</span>
            </p>
            <p>
              RANK <br /> <span style={{ color: "#ffffff" }}>6th</span>
            </p>
            <p className="p1">
              POINTS <br /> <span style={{ color: "#ffffff" }}>1659</span>
            </p>
          </div>
        </div>
      </div>

      <div className="grid-container5">
        <div className="footer_logos">
          <img className="icon" src="/images/Logo.png" alt="" />
          <img
            className="activision"
            src="/images/Activision_Logo.png"
            alt=""
          />
        </div>
        <div className="footer_links">
          <p>
            SUPPORT &nbsp; TERMS &nbsp; PRIVACY &nbsp; COOKIE POLICY &nbsp;
            COOKIE SETTINGS
          </p>
          <p className="p2">Email us: rock@jiwe.io / social@jiwe.io</p>
          <img
            className="socials"
            src="/images/Social media links.png"
            alt=""
          />
        </div>
      </div> */}
    </>
  );
}

export default HomePage;
